import React, { useState, useEffect } from 'react';
import { Radio, Button, Form, Input, Modal, message, Checkbox } from 'antd';
import dataset from '../../data/dataset';
import apis from '../../api/dataset';
import less from './common.less';
import './common.css';
import account from '@/common/account/index';
import fileSrc from './knowledge.png';

// I know i know, this is not the best solution with the tick problem. Fix me.
// @zhaoxuxu @2019-1-4
let smsRequestTimeTick = 0;
setInterval(() => {
  smsRequestTimeTick -= 1;
}, 1000);
let DownloadForm = ({ form, random, datasetType, onDone }) => {
  const { getFieldDecorator } = form;
  const [smsRequestTime, setSmsRequestTime] = useState(0);
  const [protocolChecked, setProtocolChecked] = useState(false);
  function downloadTxtFile(url) {
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        let blob = new Blob([xhr.responseText], { type: 'text/plain' });
        let fileUrl = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = fileUrl;
        a.download = '小学数学知识图谱json数据.txt';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(fileUrl);
      }
    };
    xhr.open('GET', url, true);
    xhr.send();
  }

  useEffect(() => {
    form.resetFields();
    setProtocolChecked(false);
  }, [random]);

  useEffect(() => {
    setTimeout(() => {
      if (smsRequestTime > 0) {
        setSmsRequestTime(smsRequestTimeTick);
      }
    }, 1000);
  }, [smsRequestTime]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!protocolChecked) {
      message.error('您需要同意《数据集授权协议》和《用户隐私协议》');
      return;
    }
    form.validateFields((err, values) => {
      if (!err) {
        values.dataType = datasetType;
        apis.fetchDownloadUrls(values).then(
          (data) => {
            message.success('获取下载链接成功');
            onDone();
            downloadTxtFile(
              'https://ai-fe-1304808899.cos.ap-beijing.myqcloud.com/openGraph/openGraph.txt'
            );
          },
          (error) => {
            message.error(error.msg || '获取下载链接失败');
          }
        );
      }
    });
  };

  function canClickDownloadBtn() {
    const values = form.getFieldsValue();
    if (values.purpose) {
      return true;
    }
    return false;
  }

  return (
    <Form
      onSubmit={handleSubmit}
      layout="horizontal"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
    >
      <div className={less.formItem}>
        <Form.Item label="用途" style={{ marginBottom: '48px' }}>
          {getFieldDecorator('purpose', {
            validateTrigger: 'onBlur',
            rules: [
              { required: true, message: '请填写用途' },
              {
                validator(rule, value, callback) {
                  if (!value) {
                    callback();
                    return;
                  }
                  if (value.length > 200 || value.length < 2) {
                    callback(new Error('字符数需在2-200位之间'));
                    return;
                  }
                  callback();
                }
              }
            ]
          })(<Input placeholder="请填写用途" allowClear />)}
        </Form.Item>
      </div>
      <div className={less.protocolOuter}>
        <Checkbox
          checked={protocolChecked}
          onChange={() => setProtocolChecked(!protocolChecked)}
          className={less.checkbox}
        >
          同意并接受
          <a target="_blank" href="/dataset-auth">
            《数据集授权协议》
          </a>
          和
          <a target="_blank" href="/dataset-privacy">
            《用户隐私协议》
          </a>
        </Checkbox>
      </div>
      <div className={less.tipOuter}>
        <p className={less.tip}>
          (为确保下载正常，请设置浏览器允许本站点打开多窗口)
        </p>
      </div>
      <div className={less.buttonOuter}>
        <Button
          type="primary"
          htmlType="submit"
          className={
            less.button +
            ' ' +
            (!canClickDownloadBtn() ? less.buttonDisable : '')
          }
          disabled={!canClickDownloadBtn()}
        >
          下载
        </Button>
      </div>
    </Form>
  );
};

DownloadForm = Form.create({ name: 'normal_login' })(DownloadForm);
const KnowledgeGraph = () => {
  const [isDownloadFormShow, setDownloadFormShow] = useState(false);
  const [datasetType, setDatasetType] = useState(false);
  function handleDownloadBtnClick(newDatasetType) {
    if (account.hasLoggedin()) {
      account.fetchBackendPrivAndUserInfo().then((res) => {
        if (res.code === 2000000) {
          setDatasetType(newDatasetType);
          setDownloadFormShow(true);
        } else {
          window.open('/account/login?type=knowledgeGraph');
        }
      });
    } else {
      window.open('/account/login?type=knowledgeGraph');
    }
  }
  return (
    <div className={less.ocrContainer}>
      <div className={less.banner}>
        <img
          src={dataset.banner}
          alt="助力教育AI发展"
          className={less.bannnerImage}
        />
        <div className={less.bannerContent}>
          <div className={less.bannerContentInner}>
            <p>好未来旗下真实教育场景数据</p>
            <p>助力教育AI发展</p>
          </div>
        </div>
      </div>
      <div className={less.datasetOuter}>
        <div className={less.content}>
          {dataset.knowledgeGraphList.map((item, index) => {
            return (
              <div
                className={less.contentItem}
                key={item.title}
                style={
                  index === dataset.knowledgeGraphList.length - 1
                    ? { paddingBottom: '0px' }
                    : {}
                }
              >
                <div className={less.contentItemOuter}>
                  <div className={less.contentItemInner}>
                    <div className={less.titleButton}>
                      <p className={less.title}>{item.title}</p>
                      <Button
                        className={less.downloadBtn}
                        onClick={() => handleDownloadBtnClick(item.download)}
                      >
                        下载数据集
                      </Button>
                    </div>
                    <p className={less.description}>{item.description}</p>
                    <div className={less.content}>
                      <div className={less.example}>
                        <p className={less.title}>样例：</p>
                        <img
                          src={fileSrc}
                          className={less.fileStyle}
                          alt="样例图片"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        width={608}
        height={368}
        title="下载数据集"
        bodyStyle={{ padding: '38px 0px 60px' }}
        visible={isDownloadFormShow}
        footer={null}
        onCancel={() => setDownloadFormShow(false)}
        id="datasetModal"
      >
        <div className={less.modal}>
          <div className={less.modalBody}>
            <DownloadForm
              random={Math.random()}
              datasetType={datasetType}
              onDone={() => setDownloadFormShow(false)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default KnowledgeGraph;
